<template lang="pug">
v-container.px-8.pb-8(style="max-width:1600px")
  template(v-for="setting in settings")
    .text-2xl.font-semibold.mb-4.mt-8 {{ setting.title }}
    v-card(outlined)
      v-row(no-gutters)
        template(v-for="(row, rowIdx) in setting.children")
          v-col(cols="12")
            v-row(no-gutters)
              template(v-for="(column, columnIdx) in row")
                v-col.pa-6(:cols="12/colsPerRow")
                  v-icon(size="30" color="neutral700") {{ column.icon }}
                  .text-xl.font-semibold.my-2 {{ column.title }}
                  v-list
                    template(v-for="(item, itemIdx) in column.children")
                      v-divider(v-if="itemIdx !== 0")
                      v-list-item.py-2.px-3(@click="onRouteTo(column, item)")
                        v-row(no-gutters align="center")
                          v-col(cols="9")
                            .text-sm.font-medium {{ item.title }}
                            .text-xs.font-normal.neutral500--text {{ item.description }}
                          v-spacer
                          v-col.text-right
                            v-icon(v-if="item.suffixIcon") {{ item.suffixIcon }}
                            v-icon(v-else) mdi-arrow-right
                v-divider(v-if="columnIdx !== colsPerRow - 1" vertical)
            v-divider(v-if="rowIdx !== setting.children.length - 1")
  .mt-8
    .text-sm.neutral500--text {{ $t('need_help') }}
    v-btn.text-sm.button-sm.underline.px-0(text @click="contactUs") {{ $t('contact_us') }}
  .dialogs
    subscribe-review-modal(v-if="showSubscribeReviewModal" :open.sync="showSubscribeReviewModal" :company="company" :volunteer="true" @subscribed="$store.commit('subscriptions/update')")
    subscribe-appointment-modal(v-if="showSubscribeAppointmentModal" :open.sync="showSubscribeAppointmentModal" :company="company" :volunteer="true" @subscribed="$store.commit('subscriptions/update')")
    subscribe-cms-modal(v-if="showSubscribeCmsModal" :open.sync="showSubscribeCmsModal" :company="company" :volunteer="true" @subscribed="$store.commit('subscriptions/update')")
    delete-company(v-if="deleteCompanyDialog" :open.sync="deleteCompanyDialog" :company="company")
    
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SubscribeReviewModal from '@/components/clinic/dialogs/SubscribeReviewModal.vue'
import SubscribeAppointmentModal from '@/components/clinic/dialogs/SubscribeAppointmentModal.vue'
import SubscribeCmsModal from '@/components/clinic/dialogs/SubscribeCmsModal.vue'
import DeleteCompany from '@/components/dialogs/settings/DeleteCompany.vue'

export default {
  components: {
    SubscribeReviewModal, SubscribeAppointmentModal, SubscribeCmsModal, DeleteCompany
  },
  data() {
    return {
      colsPerRow: 3,
      showSubscribeReviewModal: false,
      showSubscribeAppointmentModal: false,
      showSubscribeCmsModal: false,
      zdWidget: null,
      cwInterval: null,
      deleteCompanyDialog: false
    }
  },
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany'
    }),
    isAdmin () {
      return this.member.roles.includes('Admin')
    },
    showReport () {
      // Not cms subscribers
      if (!this.Auth('root', 'subscribe_cms')) return false
      // Special genes to hide report for certain company
      if (this.company?.genes?.find(gene => gene.feature === 'hide_cms_reports')) {
        // Hide report to non-admin member
        return this.isAdmin
      }
      // Default
      return true
    },
    // NOTE: Add/remove list of items here
    items () {
      return [
        // Clinic management
        {
          title: this.$t('clinic_management'),
          children: [
            {
              title: this.$t('in_clinic'),
              icon: '$yzi-user-circle',
              show: this.Auth('root', 'subscribe_cms'),
              children: [
                {
                  title: this.$t('registration_settings'),
                  description: this.$t('manage_registration_settings_description'),
                  route: '/admin/clinic/settings/registration-settings',
                  show: this.Auth('page', '/admin/clinic/registration')
                },
                {
                  title: this.$t('consultation_settings'),
                  description: this.$t('manage_consultation_settings_description'),
                  route: '/admin/clinic/settings/consultation-settings',
                  show: this.Auth('page', '/admin/clinic/consultation')
                },
                {
                  title: this.$t('checkout_settings'),
                  description: this.$t('manage_checkout_settings_description'),
                  route: '/admin/clinic/settings/checkout-settings'
                }
              ]
            },
            {
              title: this.$t('inventory_and_services'),
              icon: '$yzi-box',
              show: this.Auth('root', 'subscribe_cms') || this.Auth('root', 'subscribe_purchase_hub'),
              children: [
                {
                  title: this.$t('inventory_services_packages'),
                  description: this.$t('manage_inventory_services_packages_description'),
                  route: '/admin/clinic/inventory'
                },
                // {
                //   title: this.$t('services'),
                //   description: this.$t('manage_services_description'),
                //   route: '/admin/clinic/services'
                // },
                {
                  title: 'Inventory invoices',
                  description: 'Manage inventory invoices & expenses',
                  route: '/admin/clinic/inventory-invoices'
                },
                {
                  title: this.$t('settings'),
                  description: this.$t('manage_inventory_and_services_settings_description'),
                  route: '/admin/clinic/settings/price-tier-settings'
                }
              ]
            },
            {
              title: this.$t('patients'),
              icon: '$yzi-users-02',
              show: this.Auth('root', 'subscribe_cms') || this.Auth('root', 'subscribe_appointment'),
              children: [
                {
                  title: this.$t('information_and_medical_records'),
                  description: this.$t('manage_information_and_medical_records_description'),
                  route: '/admin/clinic/patients'
                },
                {
                  title: this.$t('billing_records'),
                  description: this.$t('manage_billing_records_description'),
                  route: '/admin/clinic/billings',
                  show: this.Auth('root', 'subscribe_cms')
                },
                {
                  title: this.$t('segments_blasting'),
                  description: this.$t('segments_blasting_description'),
                  route: '/admin/clinic/segments'
                }
              ]
            },
            {
              title: this.$t('appointment'),
              icon: '$yzi-calendar',
              show: this.Auth('root', 'subscribe_appointment'),
              children: [
                {
                  title: this.$t('appointment_calendar'),
                  description: this.$t('manage_appointment_calendar_description'),
                  route: '/admin/clinic/appointment'
                },
                {
                  title: this.$t('settings'),
                  description: this.$t('manage_appointment_calendar_settings_description'),
                  route: '/admin/clinic/manage'
                }
              ]
            },
            {
              title: this.$t('reviews'),
              icon: '$yzi-star-01',
              show: this.Auth('root', 'subscribe_review') && !this.Auth('root', 'subscribe_marketing'),
              children: [
                {
                  title: this.$t('reviews_and_feedbacks'),
                  description: this.$t('manage_reviews_and_feedbacks_description'),
                  route: '/admin/clinic/review'
                },
                {
                  title: this.$t('settings'),
                  description: this.$t('manage_reviews_and_feedbacks_settings_description'),
                  route: '/admin/clinic/settings/review',
                  show: this.Auth('page', '/admin/clinic/review-settings')
                },
                {
                  title: this.$t('api_key'),
                  description: 'Reading data from Yezza & manipulating sensitive objects',
                  route: '/admin/clinic/settings/review-api-key',
                  show: this.Auth('page', '/admin/clinic/review-settings')
                }
              ]
            },
            {
              title: this.$t('marketing'),
              icon: '$yzi-presentation-chart-01',
              show: this.Auth('page', '/admin/clinic/settings/marketing'),
              children: [
                {
                  title: 'Settings',
                  description: 'Configure your marketing system',
                  route: '/admin/clinic/settings/marketing'
                },
                {
                  title: this.$t('api_key'),
                  description: 'Reading data from Yezza & manipulating sensitive objects',
                  route: '/admin/clinic/settings/review-api-key',
                }
              ]
            },
            {
              title: this.$t('queue'),
              icon: '$yzi-ticket-01',
              show: this.Auth('root', 'subscribe_cms'),
              children: [
                {
                  title: this.$t('settings'),
                  description: this.$t('manage_queue_settings_description'),
                  route: '/admin/clinic/settings/queue-system'
                },
                {
                  title: this.$t('queue_screen'),
                  description: this.$t('manage_queue_screen_description'),
                  route: null,
                  externalRoute: `https://${this.company.slug}.yezza.co/qtv`,
                  suffixIcon: 'mdi-arrow-top-right'
                }
              ]
            },
            {
              title: this.$t('scheduling'),
              icon: '$yzi-cube-01',
              show: this.Auth('root', 'subscribe_cms'),
              children: [
                {
                  title: this.$t('users'),
                  show: this.Auth('page', '/admin/clinic/users'),
                  description: this.$t('manage_users_description'),
                  route: '/admin/clinic/users'
                },
                {
                  title: this.$t('rooms_and_equipments'),
                  description: this.$t('manage_rooms_and_equipments_description'),
                  route: '/admin/clinic/settings/facilities'
                }
              ]
            },
            {
              title: this.$t('documents'),
              icon: '$yzi-file-heart-02',
              show: this.Auth('root', 'subscribe_cms'),
              children: [
                {
                  title: this.$t('templates'),
                  description: this.$t('manage_templates_description'),
                  route: '/admin/clinic/settings/document/templates'
                },
                {
                  title: this.$t('drug_label'),
                  description: this.$t('drug_label_description'),
                  route: '/admin/clinic/settings/document/drug-label'
                }
              ]
            },
            {
              title: this.$t('reports'),
              icon: '$yzi-file-07',
              show: this.showReport,
              children: [
                {
                  title: this.$t('medicine_reports'),
                  description: this.$t('medicine_reports_description'),
                  route: '/admin/clinic/reports/prescription'
                },
                {
                  title: this.Auth('component', '/admin/clinic/reports/sales#view_sales_report') ? this.$t('sales_reports') : this.$t('closing_reports'),
                  description: this.Auth('component', '/admin/clinic/reports/sales#view_sales_report') ? this.$t('sales_reports_description') : this.$t('closing_reports_description'),
                  route: '/admin/clinic/reports/sales',
                  // show: this.Auth('component', '/admin/clinic/reports/sales#view_sales_report')
                },
                {
                  title: 'Panel reports',
                  description: 'Download panel reports',
                  route: '/admin/clinic/reports/panel',
                },
                {
                  title: 'Stock Movement Report',
                  description: 'View inventory movements and stock changes',
                  route: '/admin/clinic/reports/stock-movement',
                }
              ]
            },
            {
              title: 'Subscription',
              icon: '$yzi-calendar',
              show: this.Auth('component', '/admin/clinic/settings#subscription'),
              children: [
                {
                  title: 'Subscription',
                  description: 'Manage your subscriptions',
                  route: '/admin/billing/clinic-subscription'
                },
                {
                  title: 'Bills',
                  description: 'Manage your bills',
                  route: '/admin/billing/clinic-bills'
                },
              ]
            },
            {
              title: 'General',
              icon: '$yzi-settings-02',
              show: this.Auth('root', 'subscribe_appointment') && this.isAdmin,
              children: [
                {
                  title: 'Analytics',
                  show: this.Auth('component', '/admin/clinic/settings#analytics'),
                  description: 'Track your marketing performance',
                  route: '/admin/clinic/settings/analytics'
                },
                {
                  title: 'Integration',
                  show: this.Auth('component', '/admin/clinic/settings#integration'),
                  description: 'Custom domain and webhook settings',
                  route: '/admin/clinic/settings/integration'
                },
                {
                  title: 'Delete Organization',
                  show: this.Auth('component', '/admin/clinic/settings#delete_company'),
                  description: 'Stop using Yezza',
                  action: this.onDeleteCompany
                },
              ]
            },
            {
              title: this.$t('panel.panel'),
              icon: '$yzi-monitor-05',
              show: this.Auth('root', 'subscribe_cms'),
              children: [
                {
                  title: this.$t('panel.panel_reports'),
                  description: this.$t('panel.download_panel_reports'),
                  route: '/admin/clinic/reports/panel',
                },
                {
                  title: this.$t('panel.panel_invoices'),
                  description: this.$t('panel.download_panel_invoices'),
                  route: '/admin/clinic/reports/panel-invoice',
                },
                {
                  title: this.$t('panel.claims_message_templates'),
                  description: this.$t('panel.manage_message_templates_claims'),
                  route: '/admin/clinic/panels/settings/claim-message-template',
                }
              ]
            },
            {
              title: 'e-Invoice',
              icon: '$yzi-clipboard-check',
              show: this.Auth('root', 'subscribe_cms'),
              children: [
                {
                  title: 'Single and Consolidated e-invoice',
                  description: 'View and manage your e-invoice submissions',
                  route: '/admin/clinic/einvoice',
                },
                {
                  title: 'Settings',
                  description: 'Configure your e-invoice settings',
                  route: '/admin/clinic/settings/e-invoice'
                }
              ]
            },
          ]
        },
        // Business management
        {
          title: this.$t('business_management'),
          children: [
            {
              title: this.$t('your_business'),
              icon: '$yzi-home-smile',
              children: [
                {
                  title: this.$t('business_details'),
                  description: this.$t('manage_business_details_description'),
                  route: '/admin/clinic/settings/business-details'
                },
                {
                  title: this.$t('tax_settings'),
                  description: this.$t('manage_tax_settings_description'),
                  route: '/admin/clinic/settings/tax',
                  show: this.Auth('root', 'subscribe_cms')
                },
                {
                  title: this.$t('payment_gateway'),
                  description: this.$t('manage_payment_gateway_description'),
                  route: '/admin/clinic/settings/payment'
                }
              ]
            },
            {
              title: this.$t('user_management'),
              icon: '$yzi-user-03',
              show: this.Auth('page', '/admin/clinic/users'),
              children: [
                {
                  title: this.$t('users'),
                  description: this.$t('manage_users_description'),
                  show: this.Auth('page', '/admin/clinic/users'),
                  route: '/admin/clinic/users'
                },
                {
                  title: 'User logs',
                  description: 'View user logs',
                  show: this.isAdmin,
                  route: '/admin/clinic/user-logs'
                },
              ]
            },
          ]
        }
      ]
    },
    settings() {
      return this.items.filter(item => this.getShow(item))
        .map((item) => {
          return {
            ...item,
            children: this.convertToMxNArray(item.children)
          }
        })
    }
  },
  mounted () {
    this.loadContactWidget()
  },
  methods: {
    loadContactWidget () {
      window.zE(() => {
        window.zE.show()
      })
      this.cwInterval = setInterval(() => {
        const iframe = document.getElementById('launcher')
        if (iframe) {
          this.zdWidget = iframe.contentWindow.document.getElementById('Embed')
          if (this.zdWidget) {
            this.zdWidget.style.display = 'none'
            clearInterval(this.cwInterval)
          }
        }
      }, 200)
    },
    convertToMxNArray(children) {
      if (!Array.isArray(children)) throw new Error("Input must be an array.")
      let newChildren = children.filter(child => this.getShow(child))
      const n = this.colsPerRow
      const m = Math.ceil(newChildren.length / n)
      const result = []
      for (let i = 0; i < m; i++) {
        const row = []
        for (let j = 0; j < n; j++) {
          const index = i * n + j
          const child = newChildren[index]
          if (child) {
            child.children = child.children.filter(grandChild => this.getShow(grandChild))
            row.push(child)
          }
        }
        result.push(row)
      }
      return result
    },
    onRouteTo (parent, item) {
      if (item.externalRoute) {
        window.open(item.externalRoute, '_blank')
        return
      }
      if ('permission' in parent && !parent.permission) {
        if ('permission_declined_callback' in parent) {
          parent.permission_declined_callback()
        }
        return
      }
      if ('action' in item) {
        item.action()
        return
      }
      if (item.route) {
        this.$router.push(item.route)
      }
    },
    subscribeReview () {
      this.showSubscribeReviewModal = true
    },
    subscribeCMS () {
      this.showSubscribeCmsModal = true
    },
    subscribeAppointment () {
      this.showSubscribeAppointmentModal = true
    },
    contactUs () {
      if (this.zdWidget) {
        const paths = this.$route.path.split('/')
        paths.shift()
        paths.shift()
        const searchKeywords = paths.join(" ")
        window.zE('webWidget', 'helpCenter:setSuggestions', { search: searchKeywords  })
        this.zdWidget.querySelectorAll("button")[0].click()
      }
    },
    getShow (item) {
      if ('show' in item) return item.show

      return true
    },
    onDeleteCompany () {
      this.deleteCompanyDialog = true
    }
  },
}
</script>

<style lang="scss" scoped>
</style>